import { ThemeUICSSObject } from '@apia/theme';
import { userWorkResume } from './userWorkResume';
import { remoteTasks } from './remoteTasks';

export const taskList: ThemeUICSSObject = {
  userWorkResume,
  remoteTasks,
};
